export enum SessionStorageKeys {
    LastUrl = "last_url",
    AuthCode = "auth_code",
    ScopedCenter = "scoped_center",
    PostLogoutState = "post_logout_state",
}
